import { Fragment } from "react";
import { Route } from "react-router-dom";
import { PrivateRoute } from "@/components";
import { referenceAdminRoutes } from "./referenceAdminRoutes";

/**
 * Route elements for reference admin modules. Must be invoked inside `<Routes>` as
 * `{referenceAdminAppRoutes()}` - not as a component - so React Router sees only
 * `<Route>` / `<Fragment>` children.
 */
export function referenceAdminAppRoutes() {
    return (
        <>
            {referenceAdminRoutes.map((def) => {
                const List = def.listComponent;
                const Edit = def.editComponent;
                return (
                    <Fragment key={def.key}>
                        {def.hasCreateRoute && def.newPath != null && (
                            <Route
                                path={def.newPath}
                                element={
                                    <PrivateRoute roles={[...def.roles]}>
                                        <Edit />
                                    </PrivateRoute>
                                }
                            />
                        )}
                        <Route
                            path={def.editPath}
                            element={
                                <PrivateRoute roles={[...def.roles]}>
                                    <Edit />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path={def.listPath}
                            element={
                                <PrivateRoute roles={[...def.roles]}>
                                    <List />
                                </PrivateRoute>
                            }
                        />
                    </Fragment>
                );
            })}
        </>
    );
}
